import {
  ChakraProvider,
  defineConfig,
  createSystem,
  defaultConfig,
  defineRecipe,
  ChakraProviderProps,
} from "@chakra-ui/react";

const inputRecipe = defineRecipe({
  base: {
    borderRadius: "16px",
    border: "1px solid var(--Main-Border, #D1DADF)",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.10)",
  },
});

const customConfig = defineConfig({
  theme: {
    tokens: {
      fonts: {
        body: { value: "'Carlito', 'Calibri', Arial, sans-serif" },
        heading: { value: "'Carlito', 'Calibri', Arial, sans-serif" },
        mono: { value: "'Courier New', monospace" },
      },
      colors: {
        primary: {
          100: {
            value: "#0051D2",
          },
        },
      },
    },
    recipes: {
      input: inputRecipe,
    },
  },
});

const system = createSystem(defaultConfig, customConfig);

export type ProviderProps = Omit<ChakraProviderProps, "value">;

export function Provider(props: ProviderProps) {
  return <ChakraProvider value={system} {...props} />;
}
